import moment from 'moment';

export const validate = (values) => {
    const errors = {};

    if (!values.from || !values.to) {
        errors._error = 'required';
        return errors;
    }

    const dateFrom = parseInt(values.from.replace(/_/g, ''), 10);
    const dateTo = parseInt(values.to.replace(/_/g, ''), 10);
    const dateFromBc = values.fromBc;
    const dateToBc = values.toBc;

    if (!dateFrom || !dateTo) {
        errors._error = 'required';
        return errors;
    }

    // if ((!dateFrom && dateFromBc) || (!dateTo && dateToBc)) {
    //     errors._error = 'required_bc';
    //     return errors;
    // }

    if ((dateTo < dateFrom && !dateFromBc && !dateToBc) ||
        (dateTo > dateFrom && dateFromBc && dateToBc) ||
        (!dateFromBc && dateToBc && dateFrom)) {
        errors._error = 'to_exceeds_from';
        return errors;
    }

    return errors;
};

export const isInRange = (date) => {
    if (date) {
        const newDate = parseInt(date.replace(/_/g, ''), 10);

        if (moment().year() < newDate) {
            return 'out_of_range';
        }
    }
};



// WEBPACK FOOTER //
// ./src/scripts/DateRangeYearOnlyValidation.js